<template>
  <div
    class="app-main-content"
    element-loading-text=""
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
  >
    <contract-tree-grid style="flex: 1" />
  </div>
</template>

<script>
import contractTreeGrid from '@/views/cargo/v0/Information/ContractManagement/components/contractTreeGrid'

export default {
  name: 'ContractManagement',
  components: { contractTreeGrid }
}
</script>
